import React, { useEffect } from 'react'
import HeroContent from '../Hero_component/Hero';
import MakeupComp from '../MakeupComp/MakeupComp';

const Makeup = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component loads
  }, []);
  return (
    <>
       <HeroContent
        title="Makeup & Beauty"
        image={require("../../resource/Banner/branch.jpeg")}
      />
      <MakeupComp />
    </>
  )
}

export default Makeup;
